import React from 'react';
import Icon from 'components/icon/Icon';
import $ from 'jquery';

export default class MultiCheckboxFilter extends React.Component {

    // Validate data from props
    static propTypes = {
        filter: React.PropTypes.object.isRequired,
        classModifier: React.PropTypes.string,
        selectedItems: React.PropTypes.arrayOf(React.PropTypes.string).isRequired,
        toggleFilters: React.PropTypes.func,
        isFocused: React.PropTypes.bool.isRequired,
        toggleFocus: React.PropTypes.func.isRequired
    };

    // @NOTE - right ow only the multi checkbox requires the isFocused state, if in the future this
    //         is required by other filters also then we should push this function up a level to Filter list
    //         go a step further and make all filter components call the toggleFocus function when they are in focus
    componentDidMount() {
        $('body').click((e) => {
            let clickedOn = $(e.target);
            let rootClass = '.multi-checkbox-filter';
            if (!clickedOn.hasClass(rootClass) && !clickedOn.parents(rootClass).length) {
                this.props.toggleFocus.call(this, null);
            }
        });
    }

    handleTitleClick = () => {
        if (this.props.isFocused) {
            this.props.toggleFocus.call(this, null);
        } else {
            this.props.toggleFocus.call(this, this.props.filter);
        }
    }

    renderGroupTitle = () => {
        return (
            <div className="multi-checkbox-filter-title" onClick={this.handleTitleClick}>
                <h5 className='multi-checkbox-filter-title-text'>{this.props.filter.label}</h5>
                <Icon glyph='chevron-down' />
            </div>
        );
    }

    render() {
        return (
            <div className={`multi-checkbox-filter ${this.props.isFocused ? 'is-open' : ''} ${this.props.classModifier}`}>
                {this.renderGroupTitle()}
                <ul className="multi-checkbox-filter-panel">
                    {this.props.filter.values.map((value, index) => {
                        return (
                            <li key={index}
                                onClick={() => this.props.toggleFilters(this.props.filter, value)}
                                className={`multi-checkbox-filter-item ${this.props.selectedItems.includes(value) ? 'active' : ''}`}>
                                <Icon glyph='tick' />
                                <span>{value}</span>
                            </li>
                        );
                    })}
                </ul>
            </div>
        );
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/filtered-listing/filters/multi-checkbox-filter/MultiCheckboxFilter.jsx
 **/